import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { Voucher } from '../models/voucher';
import { VouchersService } from '../services/vouchers.service';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss'],
})
export class VouchersComponent implements OnInit {
  vouchers: Voucher[]=[];
  searchKey: string;
  p: number = 1;
  constructor(private mainService: VouchersService,private authService:AuthenticationService) { }

  ngOnInit() {

    let details = this.authService.getUserDetails();
    this.mainService.getAll().subscribe(data=>{
      this.vouchers = data['results'];
    });
  }


}
